import { render } from "./LandingPageFaq.vue?vue&type=template&id=547c2cf4&scoped=true"
import script from "./LandingPageFaq.vue?vue&type=script&lang=js"
export * from "./LandingPageFaq.vue?vue&type=script&lang=js"

import "./LandingPageFaq.vue?vue&type=style&index=0&id=547c2cf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547c2cf4"]])

export default __exports__